import React, { useState } from "react";
import { Pagination } from "rsuite";
import { numberFormatter } from "../../utils";
import PlusRoundIcon from "@rsuite/icons/PlusRound";

const ParametricSupplierTable = (props: any) => {
	const [limit, setLimit] = React.useState(10);
	return (
		<>
			<table className="common-table-ui" style={{ height: "90%" }}>
				<thead>
					<tr>
						<th>Supplier</th>
						<th>2023 PO Spend</th>
						<th>SKUs with Non-Optimal Prices</th>
						<th>% Cost Reduction</th>
						<th>Benefit</th>
					</tr>
				</thead>
				<tbody>
					{Array.isArray(props.data) &&
						props?.data?.map((d: any, index: any) => {
							return (
								<tr
									key={index + d.master_vendor_name}
									onClick={() => {
										props?.updateSupplier(
											d.master_vendor_name
										);
									}}
								>
									<td>
										<PlusRoundIcon
											className="plusIcon"
											onClick={() => {
												props.updateSupplier(
													d.master_vendor_name
												);
											}}
										/>
										{d.master_vendor_name}
									</td>
									<td>
										{numberFormatter(
											d.ThisYear_Spend,
											2,
											"$"
										)}
									</td>
									<td>
										{numberFormatter(
											d.skuWnonOptimalPrices,
											0
										)}
									</td>
									<td>
										{numberFormatter(d.costReduction, 0)}%
									</td>
									<td>
										{numberFormatter(d.Benifit, 0, "$")}
									</td>
								</tr>
							);
						})}
				</tbody>
			</table>
			{/* <div className="pagination-component">
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["-", "pager", "skip"]}
          total={props.data.length}
          limit={limit}
          // activePage={props.pageNumber}
          activePage={1}
          onChangePage={(e) => {
            props.updatePageNumber(e);
          }}
        />
      </div> */}
		</>
	);
};
export default ParametricSupplierTable;
